import type { ReactNode } from 'react';

import { cn } from '@/design-system/lib/cn';

/**
 * Rótulo, campo e a linha de baixo (dica ou erro) dos formulários de cadastro. O campo
 * recebe `id`; o erro vira `role="alert"` e o campo aponta para ele.
 */
export default function FormField({
  id,
  label,
  optional = false,
  hint,
  error,
  className,
  children,
}: {
  id: string;
  label: string;
  optional?: boolean;
  hint?: ReactNode;
  error?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-1.5', className)}>
      <label htmlFor={id} className="text-small font-semibold">
        {label}
        {optional ? <span className="font-normal text-ink-subtle"> (opcional)</span> : null}
      </label>
      {children}
      {error ? (
        <span id={`${id}-error`} role="alert" className="text-caption text-status-conflict">
          {error}
        </span>
      ) : null}
      {!error && hint ? <span className="text-caption text-ink-subtle">{hint}</span> : null}
    </div>
  );
}

/** Os atributos do campo para ligar ao erro de `FormField`. */
export function fieldErrorProps(id: string, error?: string) {
  return error ? { invalid: true, 'aria-describedby': `${id}-error` } : {};
}
